export const handleThemeClassName = (theme: string) => {
  switch (theme) {
    case 'light':
      document.body.classList.add('light-app-theme');
      document.body.classList.remove('dark-app-theme');
      document.body.classList.remove('night-app-theme');
      document.body.classList.remove('hacker-app-theme');
      break;
    case 'dark':
      document.body.classList.add('dark-app-theme');
      document.body.classList.remove('light-app-theme');
      document.body.classList.remove('night-app-theme');
      document.body.classList.remove('hacker-app-theme');
      break;
    case 'night':
      document.body.classList.add('night-app-theme');
      document.body.classList.remove('light-app-theme');
      document.body.classList.remove('dark-app-theme');
      document.body.classList.remove('hacker-app-theme');
      break;
    case 'hacker_theme':
      document.body.classList.add('hacker-app-theme');
      document.body.classList.remove('light-app-theme');
      document.body.classList.remove('dark-app-theme');
      document.body.classList.remove('night-app-theme');
      break;
  }
};
